import React from "react";

const Göteborg = () => {
  return (
    <div className="outer-wrapper">
      <div className="content-wrapper">
        <h2 className="content-title">Lediga lokaler i Göteborg</h2>
        <p className="content-text">
          Göteborg är Nordens ledande logistiknav och en av Sveriges starkaste
          tillväxtregioner med kluster inom fordon/elektrifiering, maritima
          näringar, logistik, life science och kultur/kreativt. Med spårvagn,
          pendel, närhet till E6/E20/E45, hamnen och Landvetter är det enkelt
          för kunder och medarbetare att ta sig hit. På Vakansa hittar du
          kontor, kontorshotell/coworking, butik/showroom, lager/logistik och
          lätt industri – vi hjälper dig jämföra alternativ och boka visning.
        </p>
        <h3>Varför hyra lokal i Göteborg?</h3>
        <ul>
          <li>
            <b>Läge & tillgänglighet:</b> Stora pendlingsstråk, hamnkoppling och
            goda vägförbindelser.
          </li>
          <li>
            <b>Starka kluster:</b> Fordon/tech runt Lindholmen/Torslanda,
            logistik i Hisingen/Arendal, kontor/handel i City/Avenyn.
          </li>
          <li>
            <b>Skalbarhet:</b> Från flexplatser och studios till våningsplan och
            lager på tusentals kvm.
          </li>
          <li>
            <b>Talangflöde:</b> Chalmers och GU driver kompetens och samverkan
            mellan akademi och näringsliv.
          </li>
        </ul>
        <h3>Populära områden</h3>
        <ul>
          <li>
            <b>City/CBD (Inom Vallgraven, Lilla Bommen, Nordstan):</b>{" "}
            Representativa kontor nära centralstationen och service.
          </li>
          <li>
            <b>Avenyn/Lorensberg:</b> Kontor/showroom med starkt kundflöde och
            kultur-/restaurangliv.
          </li>
          <li>
            <b>Linné/Majorna/Järntorget:</b> Kreativa verksamheter, studios och
            mindre kontor.
          </li>
          <li>
            <b>Lindholmen:</b> Tech/IT, mobilitet och forskning, moderna kontor
            i campusmiljö.
          </li>
          <li>
            <b>Gårda/Gullbergsvass:</b> Centrumnära kontor och kommersiella ytor
            i omvandling.
          </li>
          <li>
            <b>Högsbo/Sisjön:</b> Handel, lager och lätt industri – bra åtkomst
            och parkering.
          </li>
          <li>
            <b>Torslanda/Arendal/Skandiahamnen:</b> Fordon/industri och
            logistiknära lägen.
          </li>
          <li>
            <b>Mölndal/Åbro:</b> Kontor, labb och lätt industri söder om city,
            god regionkoppling.
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Göteborg;
